// @ts-nocheck
import React from "react";
import Select from "react-select";
import { customFilterOption, formatOptionLabel } from "../StaticData";

const PropertyReqFileds = ({
  edit,
  type,
  optionsList,
  locationList,
  handleChange,
  getLocationsList,
  handleDropdownChange,
  formData,
  errors,
  customStyles,
  getOwnerList,
  from,
}) => {
  console.log("from property feilds", from);
  return (
    <div>
      <div className="d-flex flex-wrap gap-5 mt-4">
        <div className="d-flex flex-wrap gap-5 mt-4 col-md-12">
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Owner Name<span style={{ color: "red" }}>*</span>
            </p>
            <Select
              isDisabled={type !== "add"}
              options={optionsList?.owners || []}
              // onInputChange={(e) => {
              //   getOwnerList(e);
              // }}
              value={
                optionsList?.owners?.find(
                  (o) => o.value === formData.ownerName?.id,
                ) || null
              }
              formatOptionLabel={formatOptionLabel}
              filterOption={customFilterOption}
              onChange={(e) => {
                handleDropdownChange("ownerName", {
                  id: e?.value,
                  name: e?.label,
                  email: e?.email,
                  mobile: e?.mobile,
                });
              }}
              placeholder="Select Owner"
              styles={customStyles}
            />
            {errors.ownerName && <p className="err">{errors.ownerName}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Owner ID<span style={{ color: "red" }}>*</span>
            </p>
            <input
              className="input-box"
              name="ownerId"
              value={
                optionsList?.owners?.find(
                  (o) => o.value === formData.ownerName?.id,
                )?.code
              }
              disabled
              type="text"
              placeholder="Owner ID"
            />
            {errors.ownerId && <p className="err">{errors.ownerId}</p>}
          </div>
        </div>
        {/* )} */}
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Property Name<span style={{ color: "red" }}>*</span>
          </p>
          <input
            className="input-box"
            name="propertyName"
            value={formData.propertyName}
            readOnly={!edit}
            onChange={handleChange}
            type="text"
            placeholder="User Name"
          />
          {errors.propertyName && <p className="err">{errors.propertyName}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Hotel Categories<span style={{ color: "red" }}>*</span>
          </p>

          <Select
            options={optionsList?.hotelcategories}
            isDisabled={!edit || from === "overall-properties"}
            value={
              optionsList?.hotelcategories?.find(
                (o) => o.value === formData.HotelCategories?.id,
              ) || null
            }
            onChange={(e) => {
              handleDropdownChange("HotelCategories", {
                id: e?.value,
                name: e?.label,
              });
            }}
            placeholder="Select Hotel Categories"
            styles={customStyles}
          />
          {errors.HotelCategories && (
            <p className="err">{errors.HotelCategories}</p>
          )}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Requested By<span style={{ color: "red" }}>*</span>
          </p>
          <div className="d-flex gap-3">
            <div>
              <input
                className="input-box"
                name="requestedBy"
                value={formData.requestedBy}
                disabled
                onChange={handleChange}
                type="text"
                placeholder="Requested By"
                readOnly
              />
              {errors.requestedBy && (
                <p className="err">{errors.requestedBy}</p>
              )}
            </div>
            <div>
              <input
                className="input-box"
                name="requestedtype"
                value={formData.requestedtype}
                disabled
                onChange={handleChange}
                type="text"
                placeholder="Admin"
              />
              {errors.requestedtype && (
                <p className="err">{errors.requestedtype}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Requested On<span style={{ color: "red" }}>*</span>
          </p>
          <input
            className="input-box"
            name="requestedOn"
            value={formData.requestedOn}
            disabled
            onChange={handleChange}
            type="text"
            placeholder="Requested On"
          />
          {errors.requestedOn && <p className="err">{errors.requestedOn}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Email<span style={{ color: "red" }}>*</span>
          </p>
          <input
            className="input-box"
            name="email"
            value={formData.ownerName?.email}
            // disabled

            onChange={handleChange}
            type="email"
            placeholder="Email"
          />
          {errors.email && <p className="err">{errors.email}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Contact Number<span style={{ color: "red" }}>*</span>
          </p>
          <input
            className="input-box"
            name="mobile"
            disabled
            value={formData.ownerName?.mobile}
            onInput={(e) => (e.target.value = e.target.value.slice(0, 10))}
            onChange={handleChange}
            type="number"
            placeholder="Contact Number"
          />
          {errors.mobile && <p className="err">{errors.mobile}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Country<span style={{ color: "red" }}>*</span>
          </p>
          <input
            className="input-box"
            name="country"
            value={formData.country}
            disabled
            onChange={handleChange}
            type="text"
            placeholder="Country"
          />
          {errors.country && <p className="err">{errors.country}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            State<span style={{ color: "red" }}>*</span>
          </p>
          <Select
            isDisabled={!edit || from === "overall-properties"}
            options={locationList?.states}
            placeholder="Select State"
            name="state"
            value={
              locationList?.states?.find(
                (option) => option.value === formData.state?.id,
              ) || null
            }
            onChange={(e) => {
              getLocationsList(3, e?.value);
              handleDropdownChange("state", { id: e?.value, name: e?.label });
            }}
            type="text"
            isClearable
            styles={customStyles}
          />
          {errors.state && <p className="err">{errors.state}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            City<span style={{ color: "red" }}>*</span>
          </p>
          <Select
            isDisabled={!edit || from === "overall-properties"}
            options={locationList?.cities}
            placeholder="Select City"
            name="city"
            value={
              locationList?.cities?.find(
                (option) => option.value === formData.city?.id,
              ) || null
            }
            onChange={(e) => {
              getLocationsList(4, e?.value);
              handleDropdownChange("city", { id: e?.value, name: e?.label });
            }}
            isClearable
            styles={customStyles}
          />
          {/* <input className='input-box' name="city"
                        value={formData.city}
                        onChange={handleChange} type="text" placeholder='City' /> */}
          {errors.city && <p className="err">{errors.city}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Area<span style={{ color: "red" }}>*</span>
          </p>
          <Select
            isDisabled={!edit || from === "overall-properties"}
            options={locationList?.areas}
            placeholder="Select Area"
            name="area"
            value={
              locationList?.areas?.find(
                (option) => option.value === formData.area?.id,
              ) || null
            }
            onChange={(e) => {
              handleDropdownChange("area", { id: e?.value, name: e?.label });
            }}
            isClearable
            styles={customStyles}
          />
          {/* <input className='input-box' name="city"
                        value={formData.city}
                        onChange={handleChange} type="text" placeholder='City' /> */}
          {errors.area && <p className="err">{errors.area}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Manger / Receptionist Number
            <span style={{ color: "red" }}>*</span>
          </p>
          <input
            className="input-box"
            name="managerNumber"
            readOnly={!edit}
            value={formData.managerNumber}
            onInput={(e) => (e.target.value = e.target.value.slice(0, 10))}
            onChange={handleChange}
            type="number"
            placeholder="Manager Number"
          />
          {errors.managerNumber && (
            <p className="err">{errors.managerNumber}</p>
          )}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Landmark <span style={{ color: "red" }}>*</span>
          </p>
          <textarea
            className="search-input w-100"
            name="landmark"
            value={formData.landmark}
            readOnly={!edit}
            onChange={handleChange}
            type="text"
            placeholder="Address"
          />
          {errors.propertyAddress && <p className="err">{errors.landmark}</p>}
        </div>

        <div className="d-flex gap-5 col-md-12">
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Property Address Manual <span style={{ color: "red" }}>*</span>
            </p>
            <textarea
              className="search-input w-100"
              name="propertyAddress"
              value={formData.propertyAddress}
              readOnly={!edit}
              onChange={handleChange}
              type="text"
              placeholder="Address"
            />
            {errors.propertyAddress && (
              <p className="err">{errors.propertyAddress}</p>
            )}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Property Address Automatic <span style={{ color: "red" }}>*</span>
            </p>
            <textarea
              className="search-input w-100"
              name="address"
              value={formData.address}
              readOnly={true}
              type="text"
              placeholder="Address "
            />
            {errors.propertyAddress && (
              <p className="err">{errors.propertyAddress}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyReqFileds;
